var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLsqMenuFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.125C6 5.57272 6.44772 5.125 7 5.125H12.25C12.8023 5.125 13.25 5.57272 13.25 6.125V11.375C13.25 11.9273 12.8023 12.375 12.25 12.375H7C6.44772 12.375 6 11.9273 6 11.375V6.125ZM15.625 6.125C15.625 5.57272 16.0727 5.125 16.625 5.125H21.875C22.4273 5.125 22.875 5.57272 22.875 6.125V11.375C22.875 11.9273 22.4273 12.375 21.875 12.375H16.625C16.0727 12.375 15.625 11.9273 15.625 11.375V6.125ZM15.625 15.75C15.625 15.1977 16.0727 14.75 16.625 14.75H21.875C22.4273 14.75 22.875 15.1977 22.875 15.75V21C22.875 21.5523 22.4273 22 21.875 22H16.625C16.0727 22 15.625 21.5523 15.625 21V15.75ZM6 15.75C6 15.1977 6.44772 14.75 7 14.75H12.25C12.8023 14.75 13.25 15.1977 13.25 15.75V21C13.25 21.5523 12.8023 22 12.25 22H7C6.44772 22 6 21.5523 6 21V15.75Z",
    fill: "#1B2332",
    stroke: "#1B2332",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsqMenuFilled);
export default __webpack_public_path__ + "static/media/lsq_menu_filled.73efc21fb7d02d0c4427bbe02dbce7cb.svg";
export { ForwardRef as ReactComponent };